export default function initNumberedSection() {
  document
    .querySelectorAll(".js-numbered-section")
    .forEach((section, index) => {
      const smallNumber = section.classList.contains("numbered-section--small");
      const numberElement = section.querySelector(
        ".js-numbered-section__number",
      );
      if (numberElement) {
        numberElement.textContent = index + 1 + (smallNumber ? "." : "");
      }
    });
}
